import React, { Component } from "react";

import { themeService } from "../../../theme/service/activeTheme.service";
import { switchReportStyle } from "../../Reports/sims/style";
import { getTableBody, getTableHeader } from "../OEM_HelperFunctions";
import ReportTableSectionRenderer from "../../../libraries/ReportGenerator";
import ReportTitleSection from "../../../libraries/ReportGenerator/ReportTitleSection";
import ReportFraConditionsMasterKey from "../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";

class ViewOemReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      OEMData: { ...TableOEMData },
    };
    this.getFraHeaderInfo = this.getFraHeaderInfo.bind(this);
  }
  componentDidMount() {
    if (this.props.data) {
      const FormData = processData(this.props.data);
      this.setState({
        formData: { ...FormData },

        OEMData: this.props.OEMData ? this.props.OEMData : this.state.OEMData,
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      const FormData = processData(this.props.data);
      this.setState({ formData: { ...FormData } });
    }
    if (this.props.OEMData != prevProps.OEMData) {
      this.setState({ OEMData: this.props.OEMData });
    }
  }
  getFraHeaderInfo() {}
  render() {
    const { OEMData } = this.state;
    const { configuredOEMName, asset } = this.props;
    let fraHeader = this.getFraHeaderInfo();

    return (
      <div
        className="mainContent table-report last-page-break-print"
        style={{ ...themeService(switchReportStyle.mainStyle), overflow: "auto" }}
      >
        <ReportTitleSection title={"Locomotive Engine OEM Recommended Maintenance"} fontSizeOverride={"35px"} />
        <span className="spacer"></span>
        {
          <table className="table-bordered">
            {this.props.asset &&
              customOEM.map((e, i) => (
                <ReportTableSectionRenderer
                  section={e}
                  rowsData={{
                    ...this.props.asset.assetStates,
                    ...this.props.asset,
                    ...this.props.asset.attributes,
                    oemName: configuredOEMName,
                  }}
                  key={i}
                />
              ))}
          </table>
        }

        <table style={{ width: "auto" }}>
          <thead>{getTableHeader(OEMData)}</thead>
          <tbody>{getTableBody(this.state.formData || {}, this.props.asset || {}, OEMData)}</tbody>
        </table>

        <div>
          <ReportFraConditionsMasterKey
            title={"Legends :"}
            masterKey={[
              {
                key: <span style={{ color: "green", fontSize: "larger", fontWeight: "700", fontFamily: "sans-serif" }}>{"✓"}</span>,
                value: "OEM performed as planned",
              },
              {
                key: <span style={{ color: "green", fontSize: "x-large", fontWeight: "700", fontFamily: "sans-serif" }}>{"+"}</span>,
                value: "OEM performed un-planned ",
              },
              {
                key: <span style={{ fontSize: "16px", fontFamily: "sans-serif", fontWeight: "lighter" }}>{"X"}</span>,
                value: "OEM pending/missed",
              },
            ]}
          />
        </div>
      </div>
    );
  }
}

export default ViewOemReport;

const processData = (data) => {
  return data.reduce((acc, { formData }) => {
    let engine = formData.find((e) => e.id === "engHour");
    if (engine) {
      if (!acc[engine.value]) {
        acc[engine.value] = [];
      }

      const newData = formData
        .filter((obj) => Object.keys(obj).length > 0)
        .reduce((obj, item) => {
          obj[item.name.replace("Check ", "")] = item.value;
          return obj;
        }, {});

      acc[engine.value].push(newData);
    }
    return acc;
  }, {});
};

export const customOEM = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Engine Hours",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "engineHour",
        formatter: (val) => {
          if (!val) return <span>{0}</span>;
          else return <span>{val}</span>;
        },
        // isTitleOnly: true,
      },
      {
        title: "Asset Name",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "unitId",
        // isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Asset Type",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "assetType",
        // isTitleOnly: true,
      },
      {
        title: "Configured OEM",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "oemName",
        // isTitleOnly: true,
      },
    ],
  },
];
const TableOEMData = {
  startEngHour: 1500,
  endEngHour: 18000,
  gap: 1500,
  threshold: 750,
  formID: "",
  table: [
    { checkItemName: "Engine oil filter", freq: 1, startHour: 0 },
    { checkItemName: "Engine operation", freq: 1, startHour: 0 },
    { checkItemName: "Centrifugal oil filter", freq: 1, startHour: 0 },
    { checkItemName: "Fuel filter", freq: 1, startHour: 0 },
    { checkItemName: "Valve gear", freq: 1, startHour: 0 },
    { checkItemName: "Air filters", freq: 2, startHour: 1 },
    { checkItemName: "Belt drive", freq: 3, startHour: 2 },
    { checkItemName: "Crankcase breathers", freq: 3, startHour: 2 },
    { checkItemName: "NOx sensor", freq: 3, startHour: 2 },
    { checkItemName: "Oxygen sensor", freq: 3, startHour: 2 },
    { checkItemName: "Trican sensor", freq: 3, startHour: 2 },
    { checkItemName: "Fuel injectors", freq: 6, startHour: 5 },
    { checkItemName: "Pressure pipe neck (bayonet)", freq: 6, startHour: 5 },
    { checkItemName: "Engine governor", freq: 6, startHour: 5 },
    { checkItemName: "Exhaust gas recirculation", freq: 6, startHour: 5 },
    { checkItemName: "Cylinder heads", freq: 6, startHour: 5 },
    { checkItemName: "Turbochargers", freq: 6, startHour: 5 },
    { checkItemName: "Component maintenance", freq: 6, startHour: 5 },
    { checkItemName: "HP fuel pumps", freq: 6, startHour: 5 },
    { checkItemName: "Extended component maintenance", freq: 6, startHour: 5 },
    { checkItemName: "EGR Endoscopy", freq: 2, startHour: 1 },
  ],
};



// WEBPACK FOOTER //
// ./src/components/LocomotiveOEMRecord/viewOEMReport/ViewOemReport.jsx